import { Toast } from 'vant'
import { isWechat } from '@/util/detect'
import { VueWechatAuthPlugin, SCOPES } from '@/wechat/auth'
import { http } from '@/api'
import { Wechat } from '@/api/collection'

const wechatBaseAuth = new VueWechatAuthPlugin()
const wechatUseInfoAuth = new VueWechatAuthPlugin(SCOPES[1])

wechatBaseAuth.appid = 'wxcd1be5fbc2cd4e8a'
wechatUseInfoAuth.appid = 'wxcd1be5fbc2cd4e8a'

export const next = {
  data() {
    return {
      timer: null
    }
  },
  created() {
    this.timer = setInterval(() => {
      this.handleCheck()
    }, 200)
  },
  methods: {
    handleCheck() {
      // should implement when use this mixin
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}

export const loading = {
  data() {
    return {
      toast: null
    }
  },
  methods: {
    showLoading(content, prop = 'loading') {
      this.toast = Toast.loading({
        mask: true,
        forbidClick: true,
        message: content
      })
      this.prop = prop
    },
    clearLoading() {
      if (this.toast) {
        this.toast.clear()
      }
    }
  },
  watch: {
    // should define `cLoading` in component compute props
    cLoading(n) {
      if (n) {
        return this.showLoading()
      }
      if (!n && this.toast) {
        return this.toast.clear()
      }
    }
  }
}

export const wechat = {
  data() {
    return {
      isWechat,
      wechatCode: (new URL(location.href)).searchParams.get('code'),
      fromPublic: this.$route.query.from_public
    }
  },
  created() {
    wechatUseInfoAuth.redirect_uri = location.href.replace(location.search, '')
    wechatBaseAuth.redirect_uri = location.href.replace(location.search, '')
  },
  methods: {
    async checkWechatBaseOAuthCode(storeHash = true) {
      if (!this.isWechat) {
        return
      }

      const lastUsedCode = localStorage.getItem('last-used-code')
      if (lastUsedCode === this.wechatCode) {
        this.wechatCode = ''
      }

      if (!this.wechatCode && storeHash) {
        localStorage.setItem('last-hash', location.hash)
      }
      if (!this.wechatCode) {
        wechatBaseAuth.auth()
      }

      if (storeHash) {
        const lastHash = localStorage.getItem('last-hash')
        if (lastHash && this.wechatCode) {
          location.hash = lastHash
        }
      }
      return this.wechatCode
    },
    async checkWechatUserInfoOAuthCode(storeHash = true) {
      if (!this.isWechat) {
        return
      }

      if (!this.wechatCode && storeHash) {
        localStorage.setItem('last-hash', location.hash)
      }
      if (!this.wechatCode) {
        wechatUseInfoAuth.auth()
      }

      if (storeHash) {
        const lastHash = localStorage.getItem('last-hash')
        if (lastHash && this.wechatCode) {
          location.hash = lastHash
        }
      }
      return this.wechatCode
    }
  }
}

export const checkAuth = {
  data() {
    return {
      showWechatPublicAccountQr: false
    }
  },
  methods: {
    async checkWechatAuth() {
      const lastScope = localStorage.getItem('last_scope') || SCOPES[0]
      if (!this.isWechat) {
        // this.showWechatPublicAccountQr = true
        return
      }

      if (!this.fromPublic) {
        const code = await this.checkWechatBaseOAuthCode(true)
        if (!code) {
          return
        }
        localStorage.setItem('last-used-code', code)
        const res = await http(
          {
            path: Wechat.GetWxUser.path,
            method: Wechat.GetWxUser.method,
            data: {
              code,
              scope: lastScope,
              youPlusSourceUrl: encodeURIComponent(location.href)
            }
          }
        )
        let followInfo = ''
        let openId = ''
        if(res.data) {
          try {
            const infos = res.data.split(',')
            if(infos.length > 1) {
              followInfo = infos[0].trim()
              openId = infos[1].trim()
              localStorage.setItem('openId', openId || '')
            }
          } catch (error) {
            console.error(error)
          }
        }
        //  兼容旧接口，旧接口res.data为follow信息
        if ((followInfo || res.data) === 'A') {
          localStorage.setItem('last_scope', SCOPES[1])
          this.wechatCode = ''
          this.checkWechatUserInfoOAuthCode()
          return
        } else if ((followInfo || res.data) === 'F') {
          const lastShowAt = Number(localStorage.getItem('last-public-show-at'))
          const now = Date.now()
          console.info(`===> this.noShowPublicQR ${this.noShowPublicQR}`)
          console.info(`now - lastShowAt > 1000 * 60 * 60 ${now - lastShowAt > 1000 * 60 * 60}`)
          if (now - lastShowAt > 1000 * 60 * 60 && !this.noShowPublicQR) {
            // this.showWechatPublicAccountQr = true
            localStorage.setItem('last-public-show-at', now)
          }
        }
        localStorage.setItem('last_scope', '')
      }
    }
  }

}

export const forceCheckAuth = {
  data() {
    return {
      showWechatPublicAccountQr: false
    }
  },
  methods: {
    async checkWechatAuth() {
      const lastScope = localStorage.getItem('last_scope') || SCOPES[0]
      if (!this.isWechat) {
        this.showWechatPublicAccountQr = true
        return
      }

      if (!this.fromPublic) {
        const code = await this.checkWechatBaseOAuthCode(true)
        if (!code) {
          return
        }
        localStorage.setItem('last-used-code', code)
        const res = await http(
          {
            path: Wechat.GetWxUser.path,
            method: Wechat.GetWxUser.method,
            data: {
              code,
              scope: lastScope,
              youPlusSourceUrl: encodeURIComponent(location.href)
            }
          }
        )
        if (res.data === 'A') {
          localStorage.setItem('last_scope', SCOPES[1])
          this.wechatCode = ''
          this.checkWechatUserInfoOAuthCode()
          return
        } else if (res.data === 'F') {
          this.showWechatPublicAccountQr = true
        }
        localStorage.setItem('last_scope', '')
      }
    }
  }

}
